import { Box } from "@mui/material";
import { useParams } from "react-router-dom";
import RecordListComponent from "../components/RecordList";

const RecordListPage = () => {
    const { tableName } = useParams();

    return (
        <Box sx={{ display: "flex", flexDirection: "column", marginLeft: "3px", marginRight: "3px" }}>
            <RecordListComponent key={tableName} />
        </Box>
    );
};

export default RecordListPage;